import React, {useEffect} from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import s from '../../../../styles/styles.module.css'
import { motion } from 'framer-motion';
import ProfileSettings from "./ProfileSettings/ProfileSettings";
import {useAppSelector} from "../../../../hooks/redux";
import {useNavigate} from "react-router-dom";
import KycBusiness from "./KycBusiness/KycBusiness";

const Settings = () => {

    const user = useAppSelector(state => state.userReducer.user)
    const navigate = useNavigate()

    useEffect(() => {
        if (user?.userData?.accountType?.includes('business')) {
            return
        }
        navigate("/personal_account/personal/settings")
    },[])

    return (
        <motion.div
            initial={{opacity: 0, scale: 1}}
            animate={{opacity: 1, scale: 1}}
            transition={{duration: 0.5}}
        >
            <Tabs>
                <TabList className={s.tabstitle_block}>
                    <Tab selectedClassName={s.active_tab} className={s.tabtitle}>Profile Settings</Tab>
                    <Tab selectedClassName={s.active_tab} className={s.tabtitle}>KYC</Tab>
                </TabList>

                <TabPanel>
                    <ProfileSettings/>
                </TabPanel>
                <TabPanel>
                    <KycBusiness/>
                </TabPanel>
            </Tabs>
        </motion.div>
    );
};

export default Settings;
